import { useMemoizedFn } from 'ahooks'
import { useEffect, useRef } from 'react'

/**
 * 利用useEffect实现监听某些变量变化，用于解决只想监听一个变量变化，但是监听函数里又使用了其他变量的场景
 * 会回传旧值给到回调函数,因为新值可以在fn中直接获取
 * @param deps
 * @param fn
 */
export const useWatch = <T extends any[]>(deps: T, fn: (...args: T) => void) => {
  const watchFn = useMemoizedFn(fn)
  const oldRef = useRef([] as T)
  useEffect(() => {
    watchFn(...oldRef.current)
    oldRef.current = [...deps] as T
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, watchFn])
}

/**
 * 用于把用户操作等回调变成同步await模式，方便编写流程代码
 * @returns
 */
export const usePromise = <T>() => {
  const promiseRef = useRef<{ res: (T) => void; ret: (reason?: any) => void }>()
  return {
    newPromise: useMemoizedFn(() => {
      return new Promise<T>((res, ret) => {
        promiseRef.current = { res, ret }
      })
    }),
    resolve: useMemoizedFn((val: T) => {
      promiseRef.current?.res(val)
    }),
    reject: useMemoizedFn((reason?: any) => {
      promiseRef.current?.ret(reason)
    }),
  }
}
